import { connect } from 'react-redux'
import type { State } from 'store/types'

import { setSort } from './actions'
import ClubCardModal from './ClubCardModal'
import { countriesClubShare, sort } from './selectors'

const mapStateToProps = (state: State) => ({
  countriesClubShare: countriesClubShare(state),
  sort: sort(state),
})

const mapDispatchToProps = {
  onSort: setSort,
}

export default connect(mapStateToProps, mapDispatchToProps)(ClubCardModal) as any
